import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from './components/Home';
import Helper from './components/Helper'

const Routes = () => (
  <Router>
    <Route exact path="/name=:name/imageid=:imageid" component={Home} />
    <Route exact path="/helper" component={Helper} />
    {/* <Route exact path="/admin" component={Admin} /> */}
  </Router>
);

export default Routes;